import { apiRequest } from "./client";

export type SupportMessageDto = {
  id: number;
  role: "user" | "assistant" | "system";
  content: string;
  createdAt: string;
  meta?: Record<string, unknown>;
};

export type SupportChatResponse = {
  sessionId: string;
  messages: SupportMessageDto[];
  reply: SupportMessageDto;
  escalated: boolean;
  topics: string[];
  persona?: "visitor_guide" | "exhibitor_support";
};

export const supportApi = {
  getChat(eventId: string): Promise<SupportChatResponse> {
    return apiRequest<SupportChatResponse>(`/support/${eventId}/chat`, {
      audience: "visitor",
    });
  },

  sendMessage(eventId: string, message: string): Promise<SupportChatResponse> {
    return apiRequest<SupportChatResponse>(`/support/${eventId}/chat`, {
      method: "POST",
      audience: "visitor",
      body: { message },
    });
  },

  /** Sync mini-app selected exhibition → MAX bot DM context */
  setContext(eventId: string): Promise<{ ok: boolean; eventId: string; title: string | null }> {
    return apiRequest(`/support/${eventId}/context`, {
      method: "PUT",
      audience: "visitor",
    });
  },
};
